import React from "react";
import { Grid, Typography, Box } from "@mui/material";
import { COLORS, size } from "../../utils";

export default function Location() {
  return (
    <Grid>
      <Grid item>
        <Typography
          sx={{
            fontFamily: "Space Mono",
            fontSize: size({ p: 2.5 }),
            fontWeight: 700,
            textTransform: "uppercase",
            color: `${COLORS.C1}`,
            wordSpacing: size({ p: 0.2, neg: true }),
            letterSpacing: size({ p: 0.1, neg: true }),
            textAlign: "center",
          }}
        >
          Our Location
        </Typography>
      </Grid>
      <Box sx={{
        display: "flex",
        justifyContent: "center",
        mt:'3%'
      }}>
        <Box
          sx={{
            width: "50%",
            height: 600,
            borderRadius: 2,
            overflow: "hidden",
            boxShadow: 3,
          }}
        >
          <iframe
            title="Google Map"
            src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3903.554729646978!2d79.8302803!3d11.936044899999999!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3a53617e4afd6137%3A0xcad0b8805a4329b9!2sGenesys%20Academy%20of%20Computer%20Science!5e0!3m2!1sen!2sin!4v1759730783568!5m2!1sen!2sin"
            width="100%"
            height="100%"
            style={{ border: 0 }}
            allowFullScreen=""
            loading="lazy"
            referrerPolicy="no-referrer-when-downgrade"
          ></iframe>
        </Box>
      </Box>
    </Grid>
  );
}
